import React from 'react'
import { loadStripe } from '@stripe/stripe-js'
import Content from '../../../../shared/Options/Billing/Shared/UI/Blocks/Content'

const Billing = () => {
  return <Content />
}

export default Billing
